import types from '../types';

/**
 * @param {types.Filter[]} filters
 * @returns {number}
 */
const getInitialExpandedAccordionFilterIndex = filters => {
    const selectedFilterIndex = filters.findIndex(
        filter => filter.radio && filter.radio.checked
    );

    if (selectedFilterIndex === -1) {
        return 0;
    }

    return selectedFilterIndex;
};

export default getInitialExpandedAccordionFilterIndex;
